module.exports = __webpack_public_path__ + "img/bottomimg.d1f09a7c.svg";